import { selectProjectState } from 'projectRedux/store';
import { sectionBendAdapter } from '../adapters/sectionBendAdapter';

export const {
  selectAll: selectAllSectionBends,
  selectById: selectSectionBendByKey,
  selectEntities: selectSectionBendEntities,
} = sectionBendAdapter.getSelectors((state) => selectProjectState(state).sectionbends);
